import styled from "styled-components/macro";
import { colors, borderRadius } from "shared/styles/constants";

export const ImagePreview = styled.div`
  overflow: hidden;

  display: inline-flex;
  align-items: center;
  justify-content: flex-start;

  img {
    object-fit: cover;

    border-radius: ${borderRadius.m};
    background-color: ${colors.grey1};
  }
`;
